import { render, staticRenderFns } from "./ProjectAssetRejectMessages.vue?vue&type=template&id=61d642d9"
import script from "./ProjectAssetRejectMessages.vue?vue&type=script&lang=js"
export * from "./ProjectAssetRejectMessages.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports